import { EgretLoadable } from "egret";
import { authRoles } from "../../auth/authRoles";

const ItemList = EgretLoadable({
  loader: () => import("./itemList")
});

const InvoiceList = EgretLoadable({
  loader: () => import("./invoiceList")
});

const ContactInvoiceView = EgretLoadable({
  loader: () => import("./ContactInvoiceView")
});

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: false
    },
    leftSidebar: {
      show: false,
      mode: "close"
    }
  },
  layout2Settings: {
    mode: "full",
    topbar: {
      show: false
    },
    navbar: { show: false }
  },
  secondarySidebar: { show: false },
  footer: { show: false }
};

const invoiceRoutes = [
    {
        path: "/invoice/items",
        component: ItemList,
        auth: authRoles.merchant
    },
    {
        path: "/invoice/invoices",
        component: InvoiceList,
        auth: authRoles.merchant
    },
    {
        path: "/invoice/view/:invoiceId",
        component: ContactInvoiceView,
        settings
    }
];

export default invoiceRoutes;
